// extracted by mini-css-extract-plugin
export default {"page":"mi-z","cartModal":"ni-z","checkout":"oi-z","placeholder":"pi-z","account":"qi-z"};